import { createStyles, makeStyles } from '@mui/styles'
import type { Theme } from '@mui/material/styles'
import CSS from 'csstype'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex'
    },
    formControl: {
      margin: theme.spacing(3)
    },
    formElement: {
      padding: '20px'
    },
    title: {
      textAlign: 'center'
    },
    alert: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
    },
    paper: {
      padding: theme.spacing(4),
      textAlign: 'center',
      color: theme.palette.text.secondary
    },
    Logo: {
      backgroundImage: '../../../assets/logos/wms_copy.png'
    }
  })
)

export const numberStyles: CSS.Properties = {
  marginLeft: '10px',
  WebkitAppearance: 'none'
}
